import { render, staticRenderFns } from "./product_list.html?vue&type=template&id=5228c140&"
import script from "./product_list.ts?vue&type=script&lang=js&"
export * from "./product_list.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports